import PL_utils from './vendor/pl-utils.js';
import PL_eventPath from './vendor/pl-eventPath';

const menuInit = () => {
	const ESC_NUM = 27;
	const body = document.querySelector('body');
	const menuIcon = document.querySelector('.header-menu__hamburger');
	const menuIconBoundingRect = menuIcon.getBoundingClientRect();
	const menu = document.querySelector('.header-menu nav')
	const menuLinks = menu.querySelectorAll('.header__links-section');
	const menuNav = document.getElementById('header-menu-nav');

	const closeMenu = () => {
		PL_utils.removeClass('menu-open', menuIcon);
		PL_utils.removeClass('menu-open', menu);
		menuIcon.setAttribute('aria-expanded', 'false');
		menuIcon.setAttribute('aria-label', 'open the menu');
		document.removeEventListener('click', clickOutsideEvent);
	};
	// Click outside menu event
	const clickOutsideEvent = (e) => {
        let path = PL_eventPath.getPath(e);
		// Allow menu icon click
		if (e.target === menuIcon || path.includes(menuIcon)) {
			return;
		} else if (e.target !== menuNav) {
			closeMenu();
		} else if (!path.includes(menuNav)) {
			closeMenu();
		}
	};

	// Close menu when link is clicked
	menuLinks.forEach(link => {
		link.addEventListener('click', () => {
			closeMenu();
		});
	});

	// Toggle open menu
    menuIcon.addEventListener('click', (e) => {
        e.preventDefault();
        PL_utils.toggleClass('menu-open', menuIcon);
        PL_utils.toggleClass('menu-open', menu);

        //accessibility
        let aria = menuIcon.getAttribute('aria-expanded');
        if(aria=='true'){
            menuIcon.setAttribute('aria-expanded', 'false');
			menuIcon.setAttribute('aria-label', 'open the menu');
			document.removeEventListener('click', clickOutsideEvent);
        }else{
            menuIcon.setAttribute('aria-expanded', 'true');
			menuIcon.setAttribute('aria-label', 'close the menu');
			document.addEventListener('click', clickOutsideEvent);
		}
    });

    //close menu with ESC
    document.addEventListener('keydown', (e)=>{
        let isMenuOpen = PL_utils.hasClass('menu-open', menu);
        if(isMenuOpen){
            if(e.keyCode == ESC_NUM){
                e.preventDefault;
                PL_utils.removeClass('menu-open', menu);
				PL_utils.removeClass('menu-open', menuIcon);
				document.removeEventListener('click', clickOutsideEvent);
            }
        }
	})

	// When scrolled past the hero, adds background white to the menu icon
	document.addEventListener('scroll', () => {
		const headerHero = document.querySelector('.header-hero');
		const headerHeroBoundingRect = headerHero.getBoundingClientRect();
		// Start the transition a bit earlier, when bottom of icon reaches bottom of hero.
		const heroHeightOffset = headerHeroBoundingRect.height - menuIconBoundingRect.height;
		if (window.pageYOffset >= heroHeightOffset) {
			PL_utils.addClass('on-scroll', body);
		} else {
			PL_utils.removeClass('on-scroll', body);
		}
	});

    //screenshot
    if(window.location.href.indexOf('menu=1') > 0){
        PL_utils.addClass('menu-open', menuIcon);
        PL_utils.addClass('menu-open', menu);
    }
};

export default ()=>{
	if(document.querySelector('.header-menu__hamburger')){
		menuInit()
	}
};
